import { ActionContext } from 'vuex';

import { TBaseFilterPayload } from '@/common/types/filter';
import { getLocalState } from '@/common/utils/store';

import { TFTSWeeklyFilterRequest } from '../../types/fts-weekly';
import { FTS_WEEKLY_ACTIONS_NAME, FTS_WEEKLY_MUTATIONS_NAME } from './name';
import { TFTSWeeklyState } from './types';

import { TPageMetadata } from '@/types/meta';
import links from '@/utils/links';
import request from '@/utils/request';

export async function searchTableData(
  context: ActionContext<TFTSWeeklyState, unknown>,
  payload: TBaseFilterPayload<TFTSWeeklyFilterRequest & TPageMetadata>,
) {
  return request(
    context,
    {
      url: links.ved.fts.weekly.getTableData,
      name: getLocalState(FTS_WEEKLY_ACTIONS_NAME.searchTableData),
      abortController: payload.abortController,
      method: 'post',
    },
    payload.params,
  );
}

export async function searchDeliveryTerms(context: ActionContext<TFTSWeeklyState, unknown>) {
  return request(
    context,
    {
      url: links.ved.fts.weekly.getDeliveryTerms,
      name: getLocalState(FTS_WEEKLY_ACTIONS_NAME.searchDeliveryTerms),
      mutate: getLocalState(FTS_WEEKLY_MUTATIONS_NAME.setDeliveryTerms),
    },
    {},
  );
}

export async function searchTransportTypes(context: ActionContext<TFTSWeeklyState, unknown>) {
  return request(
    context,
    {
      url: links.ved.fts.weekly.getTransportTypes,
      name: getLocalState(FTS_WEEKLY_ACTIONS_NAME.searchTransportTypes),
      mutate: getLocalState(FTS_WEEKLY_MUTATIONS_NAME.setTransportTypes),
    },
    {},
  );
}

export async function searchDeliveryGoodsPoints(context: ActionContext<TFTSWeeklyState, unknown>) {
  return request(
    context,
    {
      url: links.ved.fts.weekly.getDeliveryGoodsPoints,
      name: getLocalState(FTS_WEEKLY_ACTIONS_NAME.searchDeliveryGoodsPoints),
      mutate: getLocalState(FTS_WEEKLY_MUTATIONS_NAME.setDeliveryGoodsPoints),
    },
    {},
  );
}

export async function searchExporters(context: ActionContext<TFTSWeeklyState, unknown>) {
  return request(
    context,
    {
      url: links.ved.fts.weekly.getExporters,
      name: getLocalState(FTS_WEEKLY_ACTIONS_NAME.searchExporters),
      mutate: getLocalState(FTS_WEEKLY_MUTATIONS_NAME.setExporters),
    },
    {},
  );
}
